module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js??clonedRuleSet-5[0].rules[0]!./flatpickr.js"));
	}, "flatpickr");
}